import styled from 'styled-components';

import { colors, fontFamilySize, px } from '../../../../../../../contrib/ui';

const borderHeight = 40;
const borderWidth = 15;

export const InvitationBannerStyled = styled.div`
  background-color: white;
  box-shadow: 0 0 15px 0 rgb(24 31 77 / 15%);
  height: ${px(80)};
  min-height: ${px(80)};
  max-height: ${px(80)};
  border: 2px solid ${colors.mainColor};
  border-radius: ${px(5)};
  width: 100%;
  margin-bottom: ${px(15)};
  cursor: pointer;

  .grid-container {
    height: 100%;

    .avatar-container {
      display: flex;
      justify-content: center;
      align-items: center;

      .avatar {
        height: ${px(50)};
        width: ${px(50)};
      }
    }

    .info {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;

      .title {
        ${fontFamilySize('Medium', 14)}
      }

      .itemName {
        ${fontFamilySize('Bold', 18)}
      }
    }
    .cta {
      background-color: ${colors.mainColor};
      color: white;
      position: relative;
      text-align: center;

      &:before {
        content: '';
        width: 0;
        height: 0;
        border-style: solid;
        left: ${px(-1 * (borderWidth - 3))};
        position: absolute;

        border-width: ${px(borderHeight - 1)} 0 ${px(borderHeight - 1)} ${px(borderWidth)};
        border-color: ${colors.mainColor} transparent ${colors.mainColor} white;
        background-color: transparent;
      }

      ${fontFamilySize('Bold', 16)}

      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`;
